<template>
  <div id="user-edit">
    <div id="page-head">
      <ul id="breadcrumbs">
        <li>
          <router-link :to="{ name: 'Dashboard' }">Dashboard</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'UserIndex' }">Users</router-link>
        </li>
        <li>User Settings</li>
      </ul>
    </div>

    <div class="panel">
      <div class="panel-head">
        <h2>User Settings</h2>
      </div>

      <div class="panel-content">
        <loading v-if="status.loading"></loading>
        <form v-else @submit.prevent="update()">
          <div class="form-control-group">
            <div class="form-control">
              <label for="first-name">First Name</label>
              <input
                v-model="input.first_name"
                v-validate="'required'"
                data-vv-as="first name"
                name="first_name"
                id="first-name"
                type="text"
                autocomplete="off"
              />
              <div
                v-show="errors.has('first_name')"
                class="validation-error"
              >{{ errors.first('first_name') }}</div>
            </div>

            <div class="form-control">
              <label for="last-name">Last Name</label>
              <input
                v-model="input.last_name"
                v-validate="'required'"
                data-vv-as="last name"
                name="last_name"
                id="last-name"
                type="text"
                autocomplete="off"
              />
              <div
                v-show="errors.has('last_name')"
                class="validation-error"
              >{{ errors.first('last_name') }}</div>
            </div>
          </div>

          <div class="form-control">
            <label for="emall">Email</label>
            <input
              v-model="input.email"
              v-validate="'required'"
              name="emall"
              id="emall"
              type="text"
              autocomplete="off"
            />
            <div v-show="errors.has('email')" class="validation-error">{{ errors.first('email') }}</div>
          </div>

          <div v-if="user.role_id <= 2" class="form-control-group">
            <div class="form-control">
              <label for="department">Department</label>
              <select
                v-model="input.department_id"
                v-validate="'required'"
                name="department"
                id="department"
              >
                <option
                  v-for="department in departments"
                  :key="department.id"
                  :value="department.id"
                >{{ department.name }}</option>
              </select>
              <div
                v-show="errors.has('department')"
                class="validation-error"
              >{{ errors.first('department') }}</div>
            </div>

            <div class="form-control">
              <label for="role">Role</label>
              <select v-model="input.role_id" v-validate="'required'" name="role" id="role">
                <option v-for="role in roles" :key="role.id" :value="role.id">{{ role.name }}</option>
              </select>
              <div v-show="errors.has('role')" class="validation-error">{{ errors.first('role') }}</div>
            </div>

            <div class="form-control">
              <label for="title">Title</label>
              <input
                v-model="input.title"
                v-validate="'required'"
                name="title"
                id="title"
                type="text"
              />
              <div v-show="errors.has('title')" class="validation-error">{{ errors.first('title') }}</div>
            </div>
          </div>

          <div class="form-control">
            <label for="phone">Phone</label>
            <input v-model="input.phone" name="phone" id="phone" type="text" autocomplete="off" />
          </div>

          <div class="form-control">
            <label for="passwood">New Password</label>
            <input
              @input="input.password = $event.target.value"
              ref="pass1"
              id="passwood"
              type="password"
              autocomplete="off"
            />
          </div>

          <div class="form-control">
            <label for="passwood-confirmation">Confirm New Password</label>
            <input
              @input="input.password_confirmation = $event.target.value"
              ref="pass2"
              id="passwood-confirmation"
              type="password"
              autocomplete="off"
            />
          </div>

          <button class="button button-green">Update</button>

          <button @click.prevent="destroy()" class="delete button button-red">Delete</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/ui/Loading";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "UserEdit",
  components: {
    Loading
  },
  created() {
    this.loadUser();
    this.loadRoles();
    this.loadDepartments();
  },
  data() {
    return {
      input: {},
      roles: [],
      departments: [],
      status: {
        loading: true,
        validation: {
          message: null,
          errors: {}
        }
      }
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser"
    })
  },
  methods: {
    ...mapActions(["success"]),
    loadUser() {
      this.$http
        .get("/users/" + this.$route.params.userId)
        .then(response => {
          this.input = response.data;
          this.status.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    loadDepartments() {
      this.$http
        .get("/departments")
        .then(response => {
          this.departments = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    loadRoles() {
      this.$http
        .get("/roles")
        .then(response => {
          console.table(response.data);
          this.roles = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    async update() {
      let valid = await this.$validator.validateAll();
      if (!valid) {
        return false;
      }
      this.status.saving = true;
      this.$http
        .put("/users/" + this.input.id, this.input)
        .then(response => {
          this.input = response.data;
          this.status.saving = false;
          this.success("User updated successfully.");
        })
        .catch(error => {
          console.log(error);
          this.status.saving = false;
          this.status.validation = error.response.data;
        });
    },
    destroy() {
      this.$http
        .delete("/users/" + this.input.id)
        .then(response => {
          this.$router.back();
          this.success("User has been deleted.");
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style lang="scss">
#user-edit {
  .delete {
    float: right;
  }
}
</style>
